import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  useGetTicketsCategoryList,
  useGetTicketsPriorityList,
  useSubmitTicket,
} from "../../lib/queries/queriesAndMutations";
import { ticketSchema } from "../../lib/validation";
import Loader from "../shared/Loader";
import { CustomInput } from "../ui";
import TextArea from "../ui/TextArea";
import TicketSelect from "../ui/TicketSelect";
import TicketUploader from "../ui/TicketUploader";

export default function TicketForm() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(ticketSchema),
    defaultValues: {
      user_id: "",
      title: "",
      ticketcategory_id: "",
      ticketpriority_id: "",
      description: "",
      attachments: [],
    },
  });
  const navigate = useNavigate();

  const { data: ticketsCategoryList } = useGetTicketsCategoryList();
  const { data: ticketsPriorityList } = useGetTicketsPriorityList();
  const { mutateAsync: submitTicket, isPending } = useSubmitTicket();

  const handleBack = (e) => {
    e.preventDefault();
    navigate("/tickets/list");
  };
  const processForm = async (data) => {
    const attachments = [];
    data.attachments.forEach((item) => attachments.push(item.url));

    const body = {
      ticket: {
        title: data.title,
        ticketcategory_id: data.ticketcategory_id,
        ticketpriority_id: data.ticketpriority_id,
      },
      ticket_message: {
        text: data.description,
        attachments: attachments,
      },
    };
    try {
      const response = await submitTicket(body);
      if (response.status === 200) {
        const ticketId = response.data.id;
        navigate(`/ticketChat/${ticketId}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="h-full flex flex-col  gap-4 items-center justify-start overflow-y-scroll vanda  md:no-scrollbar  p-3 md:p-6 mx-auto    ">
      <div className="w-full bg-white p-6 rounded-[24px]  ">
        <p className="text-title-md-semibold ">ایجاد تیکت جدید </p>
        <hr className="my-2" />
        <form onSubmit={handleSubmit(processForm)} className={`grid grid-cols-2 w-full gap-2  `}>
          <TicketSelect
            register={register}
            name="ticketcategory_id"
            label="دپارتمان مربوطه"
            errors={errors.ticketcategory_id}
            options={ticketsCategoryList || []}
          />

          <TicketSelect
            register={register}
            name="ticketpriority_id"
            label="اولویت"
            errors={errors.ticketpriority_id}
            options={ticketsPriorityList || []}
          />

          <CustomInput
            control={control}
            name="title"
            label="موضوع"
            placeholder="خلاصه ای از متن پیام"
            type="text"
            errors={errors.title}
            className="col-span-2 "
          />
          <TextArea
            register={register}
            name="description"
            label="توضیحات"
            placeholder="مشکلتان را برای ما بازگو کنید..."
            type="text"
            errors={errors.description}
            className="col-span-2 xl:col-span-2"
          />

          <div className=" col-span-2  ">
            <p>آپلود فایل</p>
            <Controller
              defaultValue=""
              control={control}
              name="attachments"
              render={({ field: { onChange, value } }) => (
                <TicketUploader
                  pic_type="TICKET"
                  emptyAvatar={false}
                  fieldChange={onChange}
                  mediaUrl={value}
                  acceptedFormats={[".png", ".pdf", ".jpg", ".pdf", ".word", ".xlsx"]}
                />
              )}
            />
          </div>

          <div className="flex gap-2 self-end col-span-2           justify-end mt-4">
            <button onClick={handleBack} className="cancel-btn">
              انصراف
            </button>
            <button type="submit" className="btn-container disabled:bg-slate-400  " disabled={isPending}>
              {isSubmitting || isPending ? (
                <div className="flex gap-4 items-center">
                  <p className="text-xs">در حال ارسال</p>
                  <div className="flex-center gap-2 w-6 h-full ">
                    <Loader />
                  </div>
                </div>
              ) : (
                <p>ثبت تیکت</p>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
